module.exports = __webpack_public_path__ + "img/sec2_4.1960718a.png";